// libs
import React, {useEffect, useState} from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
// components
import Navigation from "../../components/navbar";
import FormModal from './form-modal';
import "../../assets/css/style.css";
import BreadcrumbNav from "../../components/breadcrumb-nav";
import Loading from '../../components/loading';
import Table from './table';
import Record404 from '../../components/record404';
import PrintErrorMsg from '../../components/print-error-msg';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from '../../config';
import utils from '../../utils';
import { useSelectedAccount } from '../../context/account-context';
import { navigateListPageUrl } from '../../utils/list-page-url';

function List({token, orgInfo}) {
	let query = utils.useQuery();
	const { selectedAccountId, hasSelectedAccount } = useSelectedAccount();
	const [ShowFormModalBox, setShowFormModalBox] = useState(false);
	const [FormRowId, setFormRowId] = useState(0);
	const [ListData, setListData] = useState([]);
	const [TotalListCount, setTotalListCount] = useState(0);
	const [IsLoading, setIsLoading] = useState(true);
	const [IsError, setIsError] = useState(true);
	const [Is404, setIs404] = useState(false);
	const [SearchQInputVal, setSearchQInputVal] = useState(null);

	let urlSearchQ = query.get("searchQ");

	const handleChangeSearchQuery = (event) => {
		setSearchQInputVal(event.target.value);
	}

	const submitSearchQuery = () => {
		navigateListPageUrl(selectedAccountId, { set: { searchQ: SearchQInputVal } });
	}

	const loadApiData = async () => {
		setIsLoading(true);
		if(hasSelectedAccount) {
			let apiCall = await ajaxCall.getCall(`${config.api.generic}/category`, {
				fAccount: selectedAccountId,
				fSearchQ: urlSearchQ
			}, token, {"Domain": "vyayata"});
			if(apiCall && apiCall.status) {
				setListData(apiCall.context.message.data.records);
				setTotalListCount(apiCall.context.message.data.totalCount);
				setIsLoading(false);
				setIsError(null);
				setIs404(false);
			} else {
				setListData([]);
				setTotalListCount(0);
				setIsLoading(false);
				setIs404(true);
				setIsError(null);
			}
		} else {
			setIsLoading(false);
			setIs404(false);
			setIsError("Choose a seller account in the top navigation to begin.");
		}
    }

	const LoadTable = () => {
		if(IsLoading) {
			return <Loading />
		} else if (Is404) {
			return <Record404 />
		} else if (IsError) {
			return <PrintErrorMsg msg={IsError} />
		} else {
			return <Table
				loadapidata={loadApiData}
				list={ListData}
				urlAccountId={selectedAccountId}
				orgInfo={orgInfo}
				token={token}
				onOpenFormModal={(id) => { setFormRowId(id); setShowFormModalBox(true); }}
			/>
		}
	}

	useEffect(() => {
        loadApiData();
    }, [selectedAccountId, urlSearchQ]);

	return (
		<>
			<Navigation orgInfo={orgInfo} />
			<Container>
				<Row>
					<Col>
                        <div className="mt-3">
                            <h3 className="fs-20rem text-left vt-txt-dark-blue">Product Categories</h3>
                            <BreadcrumbNav list={[{label: 'Home', url: '/'}, {label: `Categories - (${TotalListCount})`, url: false}]} />
                        </div>
                    </Col>
                    <Col>
                        <div className="text-right d-flex justify-content-end h-100 align-items-center">
                            <Button variant="primary" type="button" size="md" disabled={!hasSelectedAccount} onClick={() => { setFormRowId(0); setShowFormModalBox(true); }} className="vt-primary-btn border-0 text-white fs-14rem">ADD CATEGORY</Button>
                        </div>
                    </Col>
                    <hr />
				</Row>
				<Row>
					<Col md="5" lg="4" className="mb-3">
						<div><label className="form-label fs-13rem fw-bold">Search by name</label></div>
						<div className="input-group">
							<input type="text" className="form-control" defaultValue={urlSearchQ} onKeyUp={handleChangeSearchQuery} placeholder="Category name" aria-label="Category name" />
							<div className="input-group-append">
								<Button variant="secondary" className="btn text-white btn-outline-secondary rounded-0" onClick={submitSearchQuery} type="button" disabled={!hasSelectedAccount}>Search</Button>
							</div>
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<p className="text-muted fs-13rem">Categories are per vendor and appear on that store&apos;s website navigation. Assign them when adding inventory.</p>
					</Col>
				</Row>
				<Row>
					<Col>
						<LoadTable />
					</Col>
				</Row>
			</Container>
			{(ShowFormModalBox) ? <FormModal loadapidata={loadApiData} setshowformmodalbox={(v) => { setShowFormModalBox(v); if (!v) setFormRowId(0); }} orgaccountid={selectedAccountId} rowid={FormRowId || undefined} token={token} orginfo={orgInfo} /> : null}
		</>
	)
}

export default List;
